import React from "react";
import PageHero, { PageCTA } from "../components/PageHero";
import { Check, ShieldCheck, Award, Layers } from "lucide-react";
import { heroImages, porteBlindeeModels } from "../data/mock";

const PorteBlindee = () => {
  return (
    <div>
      <PageHero
        title="Porte blindée Fichet"
        subtitle="Depuis 1825, Fichet invente et perfectionne la porte blindée. Le savoir-faire français au service de votre sécurité."
        breadcrumb="Porte blindée"
        badge="Sécurité A2P"
        image={heroImages.porteBlindee}
      />

      {/* INTRO */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-sm font-bold text-[#8C6F14] tracking-widest uppercase mb-3">Le spécialiste depuis 1825</div>
            <h2 className="text-3xl md:text-4xl font-black tracking-tight text-black leading-tight mb-6">
              L'inventeur du bloc-porte blindé
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Spécialistes de la marque Fichet, nous entretenons, réglons et remettons en état les portes blindées certifiées A2P pour appartement et maison individuelle. Nous vous conseillons aussi sur le choix d'un bloc-porte adapté à votre logement et en assurons la pose dans les règles de l'art.
            </p>
            <p className="text-gray-700 leading-relaxed">
              De la porte d'entrée discrète aux modèles haute résistance BP3, chaque solution allie sécurité maximale, isolation thermique et esthétique contemporaine.
            </p>
          </div>
          <div className="relative">
            <div className="absolute -bottom-4 -right-4 w-40 h-40 bg-[#C9A227] z-0" />
            <img src={heroImages.porteBlindee} alt="Porte blindée Fichet" className="relative w-full h-[480px] object-cover z-10" />
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: ShieldCheck, title: "Certification A2P BP1 / BP2 / BP3", desc: "Nos portes sont homologuées par le CNPP, résistantes de 5 à 15 minutes contre l'effraction." },
              { icon: Layers, title: "Isolation thermique et phonique", desc: "Jusqu'à 45dB d'atténuation acoustique et une excellente isolation thermique certifiée ACOTHERM." },
              { icon: Award, title: "Garantie constructeur 10 ans", desc: "Fabrication française, pièces de rechange disponibles pendant 20 ans après l'installation." },
            ].map((b, i) => (
              <div key={i} className="bg-white p-8 hover:shadow-xl transition-shadow border-t-4 border-[#C9A227]">
                <b.icon className="w-10 h-10 text-black mb-4" />
                <h3 className="text-xl font-bold text-black mb-3 tracking-tight">{b.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MODELS */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-14 max-w-2xl mx-auto">
            <div className="text-sm font-bold text-[#8C6F14] tracking-widest uppercase mb-3">Nos modèles</div>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight text-black">Une gamme pour chaque besoin</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {porteBlindeeModels.map((m, i) => (
              <div key={i} className="bg-white border border-gray-200 hover:border-[#C9A227] transition-colors group">
                <div className="h-72 overflow-hidden bg-gray-100">
                  <img src={m.image} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="inline-block bg-[#123B2E] text-[#C9A227] text-xs font-bold tracking-widest uppercase px-2.5 py-1 mb-3">
                    {m.certification}
                  </div>
                  <h3 className="text-2xl font-black text-black tracking-tight mb-4">{m.name}</h3>
                  <ul className="space-y-2">
                    {m.features.map((f, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-700">
                        <Check className="w-4 h-4 text-[#8C6F14] flex-shrink-0" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageCTA title="Protégez votre foyer dès aujourd'hui" subtitle="Devis gratuit pour votre porte blindée Fichet" />
    </div>
  );
};

export default PorteBlindee;
